import { createAsyncThunk } from "@reduxjs/toolkit";
import { OnboardingV2ProgressResponse } from "@ifgengineering/client-invest-sdk";
import { logException } from "@helpers/logException/logException";
import { clientInvestSdk } from "@utils/clientInvestSdk";

const FETCH_ONBOARDING_V2_PROGRESS_API = "FETCH_ONBOARDING_V2_PROGRESS_API";

export const fetchOnboardingV2ProgressAPI = createAsyncThunk<
  OnboardingV2ProgressResponse | null
>(FETCH_ONBOARDING_V2_PROGRESS_API, async () => {
  try {
    const response = await clientInvestSdk.getOnboardingV2Progress();

    return response.data;
  } catch (e: unknown) {
    const status = (e as { response?: { status?: number } })?.response?.status;
    if (status !== 401) {
      logException({
        tag: "fetchOnboardingV2ProgressAPI",
        exception: e,
      });
    }

    return null;
  }
});
